import React from "react";

function TypeNoteChip(props) {
  return <div className="note-type-chip">{props.noteType}</div>;
}

export default TypeNoteChip;
